import { render, staticRenderFns } from "./ModalPartido.vue?vue&type=template&id=3cf3d409&"
import script from "./ModalPartido.vue?vue&type=script&lang=js&"
export * from "./ModalPartido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports